export const PRICE_MONTH_RATE = 5
